// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2yr-o","rootCenter":"LoadMoreObserver_rootCenter__2c172","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3e977"};